// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { TerceraCheckBox } from './TerceraCheckBox';
export class TerceraCheckBoxEvent extends TerceraCheckBox {
    constructor() {
        super(...arguments);
        this.BeforeChangeEvent = null;
    }
    getType() {
        return ControlsTypes.TerceraCheckBoxEvent;
    }
    private_CheckBoxClick(sender) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.get('enabled')) {
                return;
            }
            return yield new Promise(function (resolve, reject) {
                if (!isNullOrUndefined(this.BeforeChangeEvent)) {
                    this.BeforeChangeEvent(!this.get('checked'), resolve);
                }
                else {
                    this.toggle('checked');
                }
            }.bind(this)).then(function (ans) {
                this.set('checked', !!ans);
            }.bind(this));
        });
    }
}
TerceraCheckBox.extendWith(TerceraCheckBoxEvent, {
    data: function () {
        return {
            checked: false,
            text: ''
        };
    }
});
